const MORE_UNIT = 3;
const EVENT_TAG = 'dn-sp-more-list';



export default class SpNews {
  constructor() {
    this.index  = MORE_UNIT;
    this.isDone = false;
    this.$w = $(window);
    this.init();
  }

  init() {
    const my = this;

    const $container = $('.dn-top-news-sp-container');

    my.$origin = $('.dn-top-news');

    my.$el = my.$origin.clone();
    my.$el.removeClass('dn-top-news--pc').addClass('dn-top-news--sp');
    my.$el.find('.viewPC').remove();
    $container.after(my.$el);
    $container.remove();

    my.$body = my.$el.find('.dn-top-news__body');
    my.$body.after('<dd class="dn-top-news__footer"><a class="dn-top-news__more" href="javascript:void(0);">もっと見る<span class="dn-icon dn-icon-arrow-down"></span></a></dd>');
    my.$trigger = my.$el.find('.dn-top-news__footer a');

    my.$trigger.on('click', function() {
      my.more();
    });
    my.$items = my.$el.find('.dn-top-news__item');
    my.updateHeight(0);

    this.$w.on('resize.' + EVENT_TAG + ' orientationchange.' + EVENT_TAG + ' load.' + EVENT_TAG, function() {
      my.updateHeight(0);
    });
  }

  more() {
    if (this.isDone) return;
    this.setIndex(this.index + MORE_UNIT);
  }

  setIndex(index) {
    this.index = Math.min(index, this.$items.length);
    if (this.index === this.$items.length) this.done();
    this.updateHeight();
  }

  updateHeight(duration) {
    const my = this;

    duration = typeof duration === 'undefined' ? 500 : duration;

    let height = 0;

    for (let i = 0; i < this.index; i++) {
      let $item = this.$items.eq(i);
      if (!$item.get(0)) break;
      height += $item.outerHeight(true);
    }

    this.$body.stop().animate({height: height}, duration, 'swing', () => {
      if (my.isDone) my.$body.css({height: 'auto'});
    });
  }

  done() {
    this.isDone = true;
    this.$trigger.addClass('dn-top-news__more--done');
    this.$w.off('.' + EVENT_TAG);
  }
}



// WEBPACK FOOTER //
// ./src/js/top/sp-news.js